/*
 * KAS LUXURY — the size band must not follow the customer into the cart.
 *
 * WHY THIS EXISTS
 * A ring's price is carried by a hidden "Size band" variant option, because only a variant
 * can carry a price. kas-ring-size.js hides that option on the product page and picks it
 * from the size the customer chose. But Shopify builds a variant's TITLE out of its option
 * values, so the band comes back everywhere the line item is printed:
 *
 *     White / 10KT Gold / US 8.75 - 10      <- the band, which nobody chose
 *     Ring size (US): US 9                  <- the size they actually chose
 *
 * That is the same question asked twice, which is exactly the confusion hiding the band was
 * meant to remove. This takes the band off the three places the storefront prints a line
 * item: the cart page, the cart drawer, and the popup after adding to cart.
 *
 * WHAT IT CANNOT REACH, AND WHY
 * Shopify's own checkout, the order status page and the packing slip are served by Shopify
 * rather than by this theme, so they still print the whole variant title. Only Shopify Plus
 * can change those. The order confirmation EMAIL is editable, but in the admin under
 * Settings > Notifications, not from here.
 *
 * FAIL-SAFE
 * If a line item does not also show a "Ring size" property, the band is LEFT ALONE. In that
 * case the band is the only size information on the line, and showing a range is better
 * than showing nothing. So a line can never end up with no size on it at all.
 *
 * THERE IS NOT ONE BACKSLASH IN THIS FILE, ON PURPOSE. It reaches the store inside a
 * GraphQL block string, which passes backslashes through verbatim while the layers above it
 * each hold an opinion about how many to keep -- that has silently broken a regex in this
 * theme twice. [/] and [.] and [ ] do the same work as the usual escapes and cannot be
 * mangled in transit. The pattern was proved against all seven real variant-title shapes,
 * including the two-tone rings that have no colour option, before this shipped.
 */
(function () {
  'use strict';

  // " / US 8.75 - 10" at the END of a variant title. Anchored to the end so that a colour
  // or a metal value could never match it.
  var BAND = /[ ]*[/][ ]*US[ ]*[0-9]+(?:[.][0-9]+)?[ ]*[-–—][ ]*[0-9]+(?:[.][0-9]+)?[ ]*$/;

  var LINES = '.cart__form-item-variant,' +
              '.quick-cart__item-variant,' +
              '.purchase-confirmation-popup__product-variant';

  var SIZE_LABEL = 'Ring size';
  var busy = false;

  // Does this line also print the size the customer picked? The properties sit in a sibling
  // block and the wrapper differs on each of the three surfaces, so walk up a few levels
  // rather than naming a container that would only be right on one of them.
  function showsChosenSize(el) {
    var node = el;
    for (var i = 0; i < 4 && node; i++) {
      node = node.parentElement;
      if (node && node.textContent && node.textContent.indexOf(SIZE_LABEL) > -1) {
        return true;
      }
    }
    return false;
  }

  function strip() {
    if (busy) {
      return;
    }
    busy = true;
    try {
      var nodes = document.querySelectorAll(LINES);
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        var text = el.textContent;
        if (!BAND.test(text)) {
          continue;                 // already clean, or not a ring
        }
        if (!showsChosenSize(el)) {
          continue;                 // the band is the only size here: leave it
        }
        var cleaned = text.replace(BAND, '');
        if (cleaned !== '' && cleaned !== text) {
          el.textContent = cleaned;
        }
      }
    } finally {
      busy = false;
    }
  }

  function watch() {
    strip();
    // The drawer and the popup are rebuilt by the theme every time the cart changes, so
    // this has to run again on each of those renders. Stripping is idempotent -- the
    // pattern cannot match a line it has already cleaned -- so the observer settles after
    // one further pass instead of looping.
    if (typeof MutationObserver === 'function') {
      new MutationObserver(strip).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
}());